import { useNavigate, useParams } from 'react-router-dom';
import { useMutation, useQuery } from 'react-query';
import React from 'react';
import api from '../../../../components/api';

function useDetailUser() {
  /*
  *
  *
  *
  *
  *
  *
  *
  */

  /*
   * Navigation Handler
  */
  const navigation = useNavigate();
  // navigate to deleted user list
  const onNavigationToDelete = () => navigation('/user-management/deleted');

  // navigate to edit user
  const onNavigationToEditUser = (userId: string) => navigation(`/user-management/user/add/${userId}`);
  /*
   *
   *
   *
   *
   *
   *
   *
   */

  /*
  * Get Initial data from params,
  * url format : user-management/:currenScreen/:id
  * currentScreen is 'active' or 'deleted'
  */

  // Get data from url param
  const { currentScreen, id } = useParams();
  // navigate to user management landing page
  const onNavigationBack = () => {
    if (currentScreen === 'active') return navigation('/user-management/active');
    return navigation('/user-management/deleted');
  };
  // Handle if hardcode wrong url
  React.useEffect(() => {
    if (currentScreen && currentScreen !== 'active') {
      if (currentScreen !== 'deleted') onNavigationBack();
    }
  }, [currentScreen]);

  const numCurrentScreen :number | undefined = React.useMemo(() => {
    if (currentScreen) {
      if (currentScreen === 'active') return 0;
      if (currentScreen === 'deleted') return 1;
      return undefined;
    }
    return undefined;
  }, [currentScreen]);
  // Get User List depend on params currentScreen
  const { data: activeUserRes, isLoading: userListLoad } = useQuery(
    ['getAllByType', 'user', numCurrentScreen],
    () => api.user.getAllByType(numCurrentScreen!),
    {
      enabled: !!numCurrentScreen,
    },
  );
  // Find current user by params id
  const userById = React.useMemo(() => {
    const listUser = activeUserRes?.data.data;
    if (listUser && id) {
      return listUser.find((user) => user.id.toString() === id.toString());
    }
    return undefined;
  }, [activeUserRes]);

  /*
  *
  *
  *
  *
  *
  *
  *
  */

  /*
  * Update Data Handler
  * 1. Delete
  * 2. Restore
  */
  const [resultUpdate, setResultUpdate] = React.useState();

  const { isLoading: loadingDeleteUser, mutate: deleteUser } = useMutation(api.user.deleteById, {
    onMutate: (x) => console.log('onMutate', x),
    onSuccess: (res:any) => {
      console.log(res);
      setResultUpdate(res);
    },
    onError: (err:any) => {
      console.log('err', err);
      setResultUpdate(err);
    },
  });

  const handleDeleteUser = (userId:string) => {
    deleteUser(parseInt(userId, 10));
  };

  const afterDeleteUser = () => {
    setResultUpdate(undefined);
    onNavigationToDelete();
  };

  return {
    userById,
    userListLoad,
    resultUpdate,
    loadingDeleteUser,
    handleDeleteUser,
    afterDeleteUser,
    onNavigationBack,
    onNavigationToEditUser,
    currentScreen,
  };
}

export default useDetailUser;
